import md5 from 'crypto-js/md5';
import Cookies from 'js-cookie';
import AgentTool from './client';

let url = 'https://stat.headlines.pw/api/stat';
const secret = '65b355de3be081903855f8b65f6867a9b6d3ce63';

/**
 *上报easylog
 *
 * @export
 * @param {*} values    前端本地信息：例如页面加载时长等
 * @param {*} type      上报http请求类型：post,get
 * @param {*} label     上报来源：例如uc，saostar,baidu等
 * @param {*} event     上报事件名：例如load_success,ad_click等
 * @param {*} pos     上报事件名：例如点击下载按钮的位置
 * @param {*} version     上报事件名：文章页面的版本
 */
export function sendWebSiteInfo({values = {}, type = "post", label = "article_landing", event, pos = "", version}) {
  // 判断是否存在uid
  let uid = Cookies.get('_bx_uid');
  !uid && (uid = uuid(12, 16));
  values.ua = navigator.userAgent.toString();
  values.browser =  AgentTool.browser();
  values.os =  AgentTool.clientOs();
  values.pos =  pos;
  values.source =  getRequest().utm_source || '';
  values.shared_uid =  getRequest().shared_uid || '';
  values.flavor = (getRequest().utm_medium && getRequest().utm_medium.indexOf("baohay24h") >= 0) ? 'baohay24h' : 'sv';
  values.version =  version;
  values.referrer =  document.referrer;
  if (type === 'post') {
    var commonParmas = {
      key: 'topnews_share',
      noce: Math.floor(Math.random(0, 1) * 1000000) + "",
      ts: Math.floor(new Date().getTime() / 1000),
      uid: uid,
      module: label,
      event: event,
      data: JSON.stringify(values)
    }
    // secret 公钥 65b355de3be081903855f8b65f6867a9b6d3ce63
    var sign = md5(JSON.stringify(commonParmas) + secret).toString();
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${url}?sign=${sign}`, JSON.stringify(commonParmas))
    } else {
      var xhr = new XMLHttpRequest();
      xhr.open('post', `${url}?sign=${sign}`, false);
      xhr.send(JSON.stringify(commonParmas));
    }
  } else {
    var xhr = new XMLHttpRequest();
    var dataStr = qs.stringify(values);
    if (dataStr) {
      url = url.indexOf('?') > -1 ? `${url}&${dataStr}` : `${url}?${dataStr}`;
    }
    xhr.open('get', url, false);
    xhr.send();
  }
}

export function uuid(len, radix) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  var uuid = [], i;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
  } else {
    var r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  Cookies.set('_bx_uid', uuid.join(''), { expires: 365, path: '' });
  return uuid.join('');
}

export function getRequest() {
  const searchParams = location.search;
  var theRequest = {};
  if (searchParams.indexOf('?') != -1) {
    var str = searchParams.substr(1);
    var strs = str.split('&');
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
    }
  }
  return theRequest;
};





// WEBPACK FOOTER //
// ./utils/sendWebsiteInfo.js